<template>
  <betriebsanweisungProofStatus v-if="item._kind === 'created'" :item="item" />
  <span v-else class="grey--text">–</span>
</template>

<script>
import betriebsanweisungProofStatus from "./betriebsanweisungProofStatus.vue";

export default {
  name: "operatingInstructionProofStatus",
  components: { betriebsanweisungProofStatus },
  props: ["item"],
};
</script>
